const endpoints = {
  electorateLookup: '/electorate',
  preferences: '/preferences',
  candidate: '/candidate',
  booths: '/booths',
  packet: '/packet',
};

const electionCode = process.env.HTV_ELECTION ? process.env.HTV_ELECTION.toUpperCase() : null;

const configs = {
  local: {
    electionCode,
    env: 'local',
    hotJar: {
      id: 1132087,
    },
    requireAuth: false,
    authUrl: 'https://members.greens.org.au/bounce/fed22htvlocal',
  },
  sandbox: {
    electionCode,
    env: 'sandbox',
    hotJar: {
      id: 1132087,
    },
    requireAuth: false,
  },
  dev: {
    electionCode,
    env: 'dev',
    theme: 'qld',
    hotJar: {
      id: 1132087, // https://nsw19.htv.dev.greens.systems/
    },
    requireAuth: false,
    authUrl: 'https://members.greens.org.au/bounce/fed25htv',
  },
  prod: {
    electionCode,
    env: 'prod',
    hotJar: {
      id: 1214019, // https://vote.greens.org.au
    },
    requireAuth: false,
  },
};

const activeConfig = configs[process.env.HTV_ENV];

export default {
  googleMapsKey: 'AIzaSyAaxUEa0pbNYyTFnx3-8LicqY8903p8SuA',
  // This is John Twyman's personal Mapbox account API key
  mapboxApiKey: 'pk.eyJ1Ijoiam9obnR3eW1hbiIsImEiOiJjbWNjeXloZmswZHc0Mm5vZGl1bXhnczd0In0.ufpmXcAcoC4hhSFP2PpK-w',
  // mapboxApiKey: 'pk.eyJ1Ijoiam9obnR3eW1hbiIsImEiOiJjbWE0amsybHEwODV3Mm1wdWZmZm45MmZlIn0.JaQ3oYNam_rsFyR9i6Qc7A',
  googleAnalyticsCode: 'G-CGCH679EGQ',
  facebookPixelCode: '218184722269912',
  sentryDsn: 'https://991a85a0fe9aa0660989ecc5752efa39@o4507206302957568.ingest.us.sentry.io/4509166070530048',
  hotJar: {
    snippetVersion: 6,
  },
  ...activeConfig,
};
